import { render, staticRenderFns } from "./examSidebar.vue?vue&type=template&id=d1a2affe&scoped=true&"
import script from "./examSidebar.vue?vue&type=script&lang=js&"
export * from "./examSidebar.vue?vue&type=script&lang=js&"
import style0 from "./examSidebar.vue?vue&type=style&index=0&id=d1a2affe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a2affe",
  null
  
)

export default component.exports